import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./PhonePeAppForMerchantSection.css";
import AppStoreIcon from "../../../images/app-download/appstore.png";
import GoogleStoreIcon from "../../../images/app-download/googleplay.png";

const PhonePeAppForMerchantSection = () => {
    const data = useStaticQuery(graphql`
        query PhonePeAppForMerchantSectionQuery {
            mobileImage: file(
                relativePath: { eq: "app_download_for_merchants_mob-1x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(
                relativePath: { eq: "app_download_for_merchants_web-1x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    let sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    return (
        <WidgetContainer stylesClass="app-download-merchant">
            <div id="merchant-download"></div>
            <div className="app-download-merchant-overview">
                <div className="app-download-merchant-overview__img-container">
                    <h2>
                        PhonePe for <br /> Business
                    </h2>

                    <Img
                        fluid={sources}
                        alt="Download PhonePe for Business"
                        imgStyle={{
                            objectFit: "contain",
                            height: "100%",
                        }}
                    />
                </div>
                <div className="app-download-merchant-overview__content">
                    <h2>
                        PhonePe for <br /> Business
                    </h2>
                    <p>
                        Using PhonePe to accept payments as a merchant? Manage
                        your accounts &amp; store listing, increase customer
                        walk-ins and grow your business with our business app.
                    </p>
                    <div className="app-download-merchant-overview__content__download-btns">
                        <p>Download PhonePe for Business</p>
                        <div className="app-download-merchant-overview__content__download-btns__container">
                            <div>
                                <a href="https://phon.pe/ppb" target="_blank">
                                    <img
                                        src={AppStoreIcon}
                                        alt="app store icon"
                                    />
                                </a>
                            </div>
                            <div>
                                <a href="https://phon.pe/ppb" target="_blank">
                                    <img
                                        src={GoogleStoreIcon}
                                        alt="google store icon"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default PhonePeAppForMerchantSection;
